import React from 'react';
import { useTranslation } from 'react-i18next';
//api
import {
  getCookiePolicy,
  createCookiePolicy,
  updateCookiePolicy
} from 'api/company';
//components
import LegalForm from './legalForm';

const CookieForm = () => {
  const { t } = useTranslation(['backoffice']);

  return (
    <LegalForm
      fetchApi={getCookiePolicy}
      createApi={createCookiePolicy}
      updateApi={updateCookiePolicy}
      titleKey="title"
      textKey="text"
      title={t('cookies')}
      dataTestId="cookies-form"
    />
  );
};

export default CookieForm;
